/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createPaddockDiagnosis = /* GraphQL */ `
  mutation CreatePaddockDiagnosis(
    $input: CreatePaddockDiagnosisInput!
    $condition: ModelPaddockDiagnosisConditionInput
  ) {
    createPaddockDiagnosis(input: $input, condition: $condition) {
      id
      race_id
      uma_id
      user_id
      body
      attitude
      walk
      comment
      hari
      gaiboki
      hakkan
      yurui
      twoman
      saigo
      kaesiOK
      kaesiNG
      evaluation
      score
      isRecommended
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePaddockDiagnosis = /* GraphQL */ `
  mutation UpdatePaddockDiagnosis(
    $input: UpdatePaddockDiagnosisInput!
    $condition: ModelPaddockDiagnosisConditionInput
  ) {
    updatePaddockDiagnosis(input: $input, condition: $condition) {
      id
      race_id
      uma_id
      user_id
      body
      attitude
      walk
      comment
      hari
      gaiboki
      hakkan
      yurui
      twoman
      saigo
      kaesiOK
      kaesiNG
      evaluation
      score
      isRecommended
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePaddockDiagnosis = /* GraphQL */ `
  mutation DeletePaddockDiagnosis(
    $input: DeletePaddockDiagnosisInput!
    $condition: ModelPaddockDiagnosisConditionInput
  ) {
    deletePaddockDiagnosis(input: $input, condition: $condition) {
      id
      race_id
      uma_id
      user_id
      body
      attitude
      walk
      comment
      hari
      gaiboki
      hakkan
      yurui
      twoman
      saigo
      kaesiOK
      kaesiNG
      evaluation
      score
      isRecommended
      createdAt
      updatedAt
      __typename
    }
  }
`;
